import { type QuizQuestionText } from '@efdigital/ll-addon-data';
import Component from '@glimmer/component';

import type { QuizQuestionScoringEditorComponentSignature } from '../../types/question-manager';
import { CategoryScore } from './shared/category-score.gts';

export class TextScoringEditorComponent extends Component<QuizQuestionScoringEditorComponentSignature> {
  get questionData(): QuizQuestionText {
    return this.args.question.text!;
  }

  setCategoryScore = (score: number, category: string) => {
    this.questionData.score = score;
    this.questionData.category = category;
  };

  <template>
    <div class="card-body">
      <div class="form-label">If the user provides an answer, they will be
        scored as follows:</div>
      <CategoryScore
        @quiz={{@quiz}}
        @category={{@question.text.category}}
        @score={{@question.text.score}}
        @onChange={{this.setCategoryScore}}
      />
    </div>
  </template>
}
